import { initTheme } from '../site/theme.js';
import { initAppBar, initDrawer, initScrollSpy } from '../site/nav.js';
import { initCarousels } from '../site/carousel.js';
import { initPublicationFilter } from '../site/publications.js';
import { initVideoPreviews } from '../site/video-previews.js';

initTheme();
initAppBar();
initDrawer();
initScrollSpy();
initCarousels();
initPublicationFilter();
initVideoPreviews();
